import React from 'react'
import {
    Button,
    Alert,
    Spinner,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter
} from 'reactstrap';
import { formatChannel, formatTimeAgo } from 'utils/tools';

const SessionConflictModal = ({ sessionModal, setSessionModal, sessionConflictData, handleCancelSession, handleConfirmSession, confirmLoading }) => {
    return (
        <Modal isOpen={sessionModal} toggle={() => setSessionModal(false)} size="lg">
            <ModalHeader toggle={() => setSessionModal(false)}>
                ⚠️ Already Logged In
            </ModalHeader>
            <ModalBody>
                <Alert color="warning">
                    <h5 className="alert-heading">{sessionConflictData?.message}</h5>
                    <p className="mb-0">
                        Logging in here will log you out from your other active sessions.
                    </p>
                </Alert>

                {sessionConflictData?.existingSessions?.length > 0 && (
                    <div className="mt-3">
                        <h6>Active Sessions:</h6>
                        <div className="list-group">
                            {sessionConflictData?.existingSessions?.map((session, index) => (
                                <div key={index} className="list-group-item">
                                    <div className="d-flex justify-content-between align-items-start">
                                        <div>
                                            <strong>{formatChannel(session.channel)}</strong>
                                            {session.deviceId && (
                                                <div className="small text-muted">
                                                    Device: {session.deviceId}
                                                </div>
                                            )}
                                            <div className="small text-muted">
                                                IP: {session.ipAddress || 'Unknown'}
                                            </div>
                                        </div>
                                        <div className="text-end">
                                            <div className="small text-muted">
                                                {formatTimeAgo(session.lastAccessedAt)}
                                            </div>
                                            {session.location && (
                                                <div className="small text-muted">
                                                    {session.location}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                <div className="mt-4">
                    <p className="text-muted">
                        <small>
                            <i className="fas fa-info-circle me-1"></i>
                            This is a security feature to prevent multiple simultaneous logins.
                        </small>
                    </p>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    color="secondary"
                    onClick={handleCancelSession}
                    disabled={confirmLoading}
                >
                    Cancel
                </Button>
                <Button
                    color="primary"
                    onClick={handleConfirmSession}
                    disabled={confirmLoading}
                >
                    {confirmLoading ? (
                        <>
                            <Spinner size="sm" className="me-2" />
                            Processing...
                        </>
                    ) : (
                        'Continue & Logout Others'
                    )}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default SessionConflictModal
